import React, { useContext } from "react";
import { css } from "emotion";
import { BuildContext } from "../../context/BuildSpotlightState";
import { boxStyles } from "../../styles/theme";
import SelectTypeList from "./SelectTypeList";
import HeadlineBuilder from "./HeadlineBuilder";
import AudioBuilder from "./AudioBuilder";
import CtaBuilder from "./CtaBuilder";
import BackgroundBuilder from "./BackgroundBuilder";
import SaveSpotlight from "./SaveSpotlight";
import FooterContainer from "./FooterContainer";
import BuildHeaderDesktop from "./BuildHeaderDesktop";

const BuildBody = () => {
  const { stage } = useContext(BuildContext);

  const doSwitch = () => {
    switch (stage) {
      case 0:
        return <SelectTypeList />;
      case 1:
        return <HeadlineBuilder />;
      case 2:
        return <AudioBuilder />;
      case 3:
        return <CtaBuilder />;
      case 4:
        return <BackgroundBuilder />;
      case 5:
        return <SaveSpotlight />;
    }
  };

  return (
    <div className={container}>
      <BuildHeaderDesktop />
      <div className="body">{doSwitch()}</div>
      <div className="footer-container">
        {stage !== 0 && <FooterContainer />}
      </div>
    </div>
  );
};

export default BuildBody;

const container = css`
  height: 100%;
  display: flex;
  flex-direction: column;

  .body {
    padding: 0 0 20px 0;
    
    >* {
      width: 100%;
    }
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    .footer-container {
      position: fixed;
      bottom: 30px;
      left: calc(50% + 160px);
      transform: translateX(-50%);
    }
    
    .body {
      flex: 1;
      align-items: center;
      justify-content: center;
      display: flex;
      
      >* {
        margin-bottom: 0;
        margin-top: 0;
      }
    }
  }

  @media screen and (max-width: ${boxStyles.desktopBreak}) {
    .footer {
      position: fixed;
      bottom: 0;
      right: 0;
      background-color: white;
    }
  }
`;
